import LinksSection from '@comparacar/components/src/molecules/LinksSection'
import deviceState from '@comparacar/components/src/state/device'
import engineState from '@comparacar/components/src/state/engine'
import { iSubscribeCarProps } from '@comparacar/lib/src/nextCommon/pages/assinar/carro/[[...slug]]'
import Divider from '@mui/material/Divider'
import React, { ReactElement, useEffect } from 'react'
import { useSetRecoilState } from 'recoil'
export { getServerSideProps } from '@comparacar/lib/src/nextCommon/pages/assinar/carro/[[...slug]]'

import Layout from '../../../template/Layout'
import Result from '../../../template/Result'
import { NextPageWithLayout } from '../../_app'

const ResultPage: NextPageWithLayout<iSubscribeCarProps> = ({ data, device, paginationInfo, links, banners }) => {
  const setEngine = useSetRecoilState(engineState)
  const setDevice = useSetRecoilState(deviceState)

  useEffect(() => {
    setEngine('subscribe')
    setDevice(device)
  }, [])

  return (
    <>
      <Result
        data={data}
        paginationInfo={paginationInfo}
        banners={banners.map(banner => ({ link: banner.url, image: banner.desktopImage, id: banner.name }))}
      />
      <Divider sx={{ marginY: 3 }} />
      <LinksSection urlPrefix="/assinar/carro/" links={links} />
    </>
  )
}

ResultPage.getLayout = function getLayout(page: ReactElement) {
  return <Layout>{page}</Layout>
}

ResultPage.displayName = 'SubscribeCar'

export default ResultPage
